
import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isAuthenticated: !!localStorage.getItem("authToken"), // Check token on load
  user: null,
  // authToken: localStorage.getItem("authToken") || null, // Persist authToken
  username: localStorage.getItem("username") || null, 
  admin: localStorage.getItem("admin") || null, 
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    loginSuccess: (state, action) => {
      state.isAuthenticated = true;
      state.user = action.payload.user;
      state.authToken = action.payload.authToken;

      // Store authToken in localStorage
      localStorage.setItem("authToken", action.payload.authToken);
      localStorage.setItem("username", action.payload.user.username); 
      localStorage.setItem("admin", action.payload.user.admin); 
    },
    logout: (state) => {
      state.isAuthenticated = false;
      state.user = null;
      state.authToken = null;
      state.username = null;
      state.admin = null;

      // Clear token from localStorage
      localStorage.removeItem("authToken");
      localStorage.removeItem("username");
      localStorage.removeItem("admin");
      localStorage.removeItem("planningLock");
    },
  },
});

export const { loginSuccess, logout } = authSlice.actions;
export default authSlice.reducer;